import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Button, Grid } from 'semantic-ui-react'
import isEqual from 'lodash/isEqual'
import find from 'lodash/find'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { LKButton } from 'loankeeper-common/components'
import { Storage } from 'loankeeper-common/helpers'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'
import mainTranslate from 'loankeeper-common/helpers/language'
import LKModal, { LKModalTrigger, LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { DataSegment as DataSegmentBase } from 'shared/Helpers'
import { GridContainer } from 'shared/StyledComponents'
import { reactForm, FormField } from 'shared/reactForm'
import { withConstantPermissions, withLivedata, colors, withUserConfig, withSystemConfig } from 'shared'
import withLookups, { LookupType } from 'shared/containers/withLookups'
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'

import { loadProductDetailsIfNeeded } from '../../store/product'
import { beforeLoanCover, view as eventView } from '../../store/event'
import { MODAL_NAME, CLOSE_CHECK_MODAL } from './constants'
import LoanCloseCheck from './LoanCloseCheck'
import CommentsModal from '../OrderAdd/CommentsModal'
import { printReport } from '../OrderAdd/helpers'
import ClientDetailsModalTrigger from '../shared/Modals/LoanTransactionDisburse/ClientDetailsModal'
import ActiveNotesModal, { openActiveNotesModal } from '../LoanDetails/ActiveNotesModal'
import { PhysicalClientDetailsModal } from '../ClientDetails/ClientPhysical'
import ClientValidationResults from '../shared/Modals/ClientValidationResults'
import {
  loadClientLinkedFiles,
  loadClientDetails,
  loadClientCashDocs,
  loadClientDelegateCashDocs,
} from '../../store/client'
import { getOrderRate } from 'src/store/rates'
import { loanCover, loanView } from 'src/store/loan'

function findCashAccountByID(CashAccounts, searchID) {
  return CashAccounts.find((item) => item.ID === searchID)
}

const Hr = () => <hr style={{ margin: 5, marginLeft: -5, marginRight: -5 }} />

const borderBottom = { borderBottom: '1px solid lightgrey' }

const DateFieldWrapper = styled.div`
  margin-left: 5px;

  * {
    color: initial !important;
  }
`

const LoanCoverFooterInfoWrapper = styled.div`
  &.loan-cover__footer-info {
    display: flex;
    align-items: center;
    justify-content: space-between;

    *:not(i) {
      font-size: 14px !important;
    }
  }
`

const DataSegment = ({ className, style, children, center }) => (
  <DataSegmentBase
    className={`u-fluid ${(center && 'u-textCenter ') || ''}${className || ''}`}
    style={{
      ...style,
      backgroundColor: 'whitesmoke',
      height: 32,
      width: '100%',
      overflowX: 'auto',
    }}
  >
    {children}
  </DataSegmentBase>
)

const LKCustomButton = ({ children, style, ...rest }) => (
  <LKButton style={{ marginRight: 0, ...style }} {...rest}>
    {children}
  </LKButton>
)

const translate = (key) => mainTranslate(`frm_acc_loan_cover-${key}`)
const translateLKM = (name) => mainTranslate(`LKMESSAGE-${name}`)
const translateWeb = (key) => mainTranslate(`frm_web_messages-${key}`)
const translateAccLoanCover = (key) => mainTranslate(`frm_acc_loan_cover-${key}`)

const withEntryDetails = (Component) => (props) => {
  const { client } = props

  const [entryDetails, setEntryDetails] = React.useState(() => ({
    Name: client.FName,
    Surname: client.LName,
    IDCardTypeID: client.IDCardTypeID,
    CardNumber: client.CardNumber,
    IDCardIssuerID: client.IDCardIssuerID,
    CitizenshipID: client.CitizenshipID,
    DOB: client.DOB,
    CityID: client.CityID,
    Address: client.Address,
    OtherIDNumber: client.IDSerial,
    IDCardRegDate: client.IDCardRegDate,
    IDValidityDate: client.IDValidityDate,
    CellPhone: client.CellPhone,
    clientIsChosen: true,
    clientID: client.ID,
    clientHash: client.HashSum_ClientID_,
    clientType: client.ClientTypeID,
    ClientType: client.ClientTypeID.toString(),
    Client: client,
  }))

  const assignEntryDetails = React.useCallback(
    (updateChunk) => {
      setEntryDetails((state) => ({
        ...state,
        ...updateChunk,
      }))
    },
    [setEntryDetails],
  )

  return <Component {...props} entryDetails={entryDetails} assignEntryDetails={assignEntryDetails} />
}

const fetcher = (Component) =>
  class Fetcher extends React.Component {
    state = { fetching: true }

    componentDidMount() {
      if (!this.props.CanViewClient) this.props.openError('VIEW_CLIENT')

      if (!this.props.CanViewClient) {
        this.props.closeModal()
        return
      }

      const { ID, hash } = this.props.params

      // loading actions dont show otherwise
      loadingActions.start()

      Promise.all([
        // Loan.details({ ID, hash, page: 'base' }),
        // Loan.details({ ID, hash, page: 'accounts_cover' }),
        // Loan.details({ ID, hash, page: 'coveropercount' }),
        // Loan.details({ ID, hash, page: 'conditions_curr' }),
        // Loan.accountsCoverCash(ID, hash),
        //UPDATED API REQUEST loan_view_api page: base
        this.props.loanView({ LoanID: ID, HashSum_LoanID_: hash, page: 'base' }),
        //UPDATED API REQUEST loan_view_api page: accounts_cover
        this.props.loanView({ LoanID: ID, HashSum_LoanID_: hash, page: 'accounts_cover' }),
        //UPDATED API REQUEST loan_view_api page: coveropercount
        this.props.loanView({ LoanID: ID, HashSum_LoanID_: hash, page: 'coveropercount' }),
        //UPDATED API REQUEST loan_view_api page: conditions_curr
        this.props.loanView({ LoanID: ID, HashSum_LoanID_: hash, page: 'conditions_curr' }),
        //UPDATED API REQUEST loan_view_api page: accounts_cover_cash
        this.props.loanView({ LoanID: ID, HashSum_LoanID_: hash, page: 'accounts_cover_cash' }),
      ])
        .then(
          ([
            baseResult,
            accountsCoverResult,
            coverOperAccountResult,
            conditionsCurrResult,
            accountsCoverCashResult,
          ]) => {
            if (
              !loanView.fulfilled.match(baseResult) ||
              !loanView.fulfilled.match(accountsCoverResult) ||
              !loanView.fulfilled.match(coverOperAccountResult) ||
              !loanView.fulfilled.match(conditionsCurrResult) ||
              !loanView.fulfilled.match(accountsCoverCashResult)
            ) {
              throw {}
            }

            const { payload: loan } = baseResult
            const { payload: accounts } = accountsCoverResult
            const {
              payload: { OperCNT },
            } = coverOperAccountResult
            const {
              payload: [conditions],
            } = conditionsCurrResult

            const { payload: CashAccounts } = accountsCoverCashResult

            if (
              (loan.ProductType === 4 && !this.props.CanCoverLMB) ||
              (loan.ProductType !== 4 && !this.props.CanCover)
            ) {
              this.props.openError(loan.ProductType === 4 ? 'LOAN_COVER_LMB' : 'LOAN_COVER')
              this.props.closeModal()
            }

            if (loan.StateID === 2 && !this.props.CanCoverClosed) {
              this.props.closeModal()
              return Promise.reject(new Error('LOAN_COVER_CLOSED'))
            }

            if (!conditions || conditions.length < 1) {
              this.props.closeModal()
              return Promise.reject(new Error(translateLKM('HINT_ERR_TITLE')))
            }

            this.loan = loan
            this.accounts = accounts
            this.coverCount = OperCNT
            this.conditions = conditions
            this.CashAccounts = CashAccounts

            return Promise.all([
              this.props.loadClientDetails({
                clientId: loan.ClientID,
                clientHash: loan.HashSum_ClientID_,
              }),
              this.props.loadProductDetailsIfNeeded({
                productId: loan.ProductID,
                productHash: loan.HashSum_ProductID_,
              }),
              // loan.ClientNoteCount > 0 || loan.LoanNoteCount > 0
              //   ? Loan.fetchLoanNotes(ID, hash)
              //   : Promise.resolve({ Data: [] }),
              //UPDATED API REQUEST loan_view_api page:activenotes
              loan.ClientNoteCount > 0 || loan.LoanNoteCount > 0
                ? this.props.loanView({ LoanID: ID, HashSum_LoanID_: hash, page: 'activenotes' })
                : Promise.resolve({ payload: [] }),
            ])
          },
        )
        .then(([clientDetailsResult, product, activeNotesResponse]) => {
          if (loanView.rejected.match(activeNotesResponse)) {
            return
          }
          this.client = clientDetailsResult.payload
          this.product = product
          this.activeNotes = activeNotesResponse.payload
          this.setState({ fetching: false })
        })
        .catch((e) => {
          this.props.openError(e && (e.message || (e.Error && (e.Error.Message || e.Error.Text))))
          this.props.closeModal()
        })
        .finally(() => loadingActions.stop())
    }

    render() {
      if (this.state.fetching) {
        return null
      }

      return (
        <Component
          {...this.props}
          client={this.client}
          loan={this.loan}
          accounts={this.accounts}
          product={this.product}
          coverCount={this.coverCount}
          activeNotes={this.activeNotes}
          CashAccounts={this.CashAccounts}
          conditions={this.conditions}
        />
      )
    }
  }

@LKModalContainer(MODAL_NAME)
@withRouter
@withConstantPermissions([
  'LOAN_COVER_CORRECT as CanCorrect',
  'LOAN_COVER_ALLOCATE as CanAllocate',
  'EDIT_CLIENT as CanEditClient',
  'LOAN_COVER_OPER as CanCoverOper',
  'LOAN_COVER_OPER_LMB as CanCoverOperLMB',
  'LOAN_COVER as CanCover',
  'LOAN_COVER_LMB as CanCoverLMB',
  'VIEW_CLIENT as CanViewClient',
  'ACC_ENTRIES_VIEW as CanViewEntries',
  'LOAN_COVER_CLOSED as CanCoverClosed',
  'PRINT_LOAN_INVOICE as CanPrintInvoice',
  'ACC_ENTRIES_ADD_CASHIN as CanAddCashin',
])
@withConstantPermissions()
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDayStr', 'CCYOfficalRates', 'CCYCommercialRates'])
@withLookups({ type: 'acc', query: 'OpCode' })
@withUserConfig(['NodeID', 'LocalCCY'])
@withSystemConfig(['InterestPriority', 'Limit_CashOper_Req', 'Limit_Conv_Req', 'Limit_Conv_Req_IDCopy'])
@withLookups({ type: LookupType.Users, query: '* as users' })
@connect(undefined, {
  openError: (message) => LKModalActions.openError(message),
  openInfo: (message, onClose) => LKModalActions.openInfo(message, undefined, onClose),
  openCloseCheck: ({ ID, hash, RevolvingID, Location }) =>
    LKModalActions.open({ name: CLOSE_CHECK_MODAL, ID, hash, RevolvingID, Location }),
  openClientFiles: () => LKModalActions.open({ name: 'ClientFilesIDCopy' }),
  openActiveNotesModal,
  openModal: LKModalActions.open,
  openMatrixConfirmation: () =>
    LKModalActions.openConfirmation('CONFIRM_MATRIX_WARNING', {
      message: translateLKM('CONFIRM_VALIDATION_WARNING_OVERRIDE'),
    }),
  loadClientLinkedFiles,
  loadClientDetails,
  loadClientCashDocs,
  loadClientDelegateCashDocs,
  loadProductDetailsIfNeeded,
  beforeLoanCover,
  eventView,
})
@connect()
@connect(undefined, (dispatch) => ({
  getOrderRate: (params) => dispatch(getOrderRate(params)),
  loanView: (params) => dispatch(loanView(params)),
  loanCover: (params) => dispatch(loanCover(params)),
}))
@fetcher
@withEntryDetails
@reactForm({
  formName: 'LoanCover',
  storageFields: ['CashOrder', 'print', 'printOption'],
  initialValues: (props) => ({
    CashOrder: !!props.CanAddCashin && !!props.CanViewEntries && !!props.CashAccounts.length,
    CashAccountID: 0,
    OpCodeID: 0,

    print: false, //! !props.CanViewEntries, // true
    printOption: '1',

    CashAuth: true,
    CalcDate: props.OpenDayStr,
    CoverDate: props.OpenDayStr,

    GROSS_Cover: 0,
    GROSS_Cover_EQ: 0,

    Auto: ['3', '4', '5'].includes(props.InterestPriority),

    SelectPrincipal: true,
    SelectInterestScheduled: ['1', '3', '4', '5'].includes(props.InterestPriority),
    SelectInterestAccrued: ['2'].includes(props.InterestPriority),
    SelectPenaltyPri: true,
    SelectPenaltyInt: true,
    SelectProcFee: true,
    SelectInsurance: true,
    SelectUCLC: true,
    SelectAdvFee: true,

    Interest_Corr: 0,
    PenaltyPri_Corr: 0,
    PenaltyInt_Corr: 0,
    ProcFee_Corr: 0,
    Insurance_Corr: 0,
    UCLC_Corr: 0,

    FreezePrincipal: false,
    FreezeInterest: false,
    FreezePenaltyPri: false,
    FreezePenaltyInt: false,
    FreezeProcFee: false,
    FreezeInsurance: false,
    FreezeUCLC: false,
    FreezeAdvFee: false,

    Principal_Cover: 0,
    Interest_Cover: 0,
    PenaltyPri_Cover: 0,
    PenaltyInt_Cover: 0,
    ProcFee_Cover: 0,
    Insurance_Cover: 0,
    UCLC_Cover: 0,
    AdvFee_Cover: 0,

    Prolongate: false,
    ProlongateNextPaymentDate: '',
  }),
})
class LoanCover extends React.Component {
  constructor(props) {
    super(props)

    this.client = props.client
    this.loan = props.loan
    this.product = props.product
    this.accounts = props.accounts
    this.conditions = props.conditions

    this.CashAccounts = props.CashAccounts.map(({ ID, TitleFull, CCY }) => ({
      value: ID,
      text: `${TitleFull} | ${CCY}`,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ flex: 1, paddingRight: 10 }}>{TitleFull}</div>
          <div style={{ width: 50 }}>{CCY}</div>
        </div>
      ),
    }))

    this.OpCodes = props.OpCode.filter((code) => code.EntryOperTypeID === 3 || code.ID === 0).map((code) => ({
      value: code.ID,
      text: `${code.Code} - ${code.Destination}`,
    }))

    this.Accounts = this.accounts.map(({ ID: value, TitleFull, CCY, Node: node }) => ({
      value,
      text: TitleFull,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ flex: 1, paddingRight: 10 }}>{TitleFull}</div>
          <div style={{ width: 50 }}>{CCY}</div>
          <div>{node}</div>
        </div>
      ),
    }))

    const CashAccountID =
      props.CashAccounts &&
      props.CashAccounts.length &&
      (props.CashAccounts.find((a) => a.CCY === this.loan.ISO) || props.CashAccounts[0]).ID

    props.form.initialize(
      {
        AccountID: this.Accounts[0].value,
        CashAccountID,
      },
      () => {
        if (!props.CanAddCashin || !props.CashAccounts.length) {
          props.form.changeValues({ CashOrder: false })
        }
      },
    )

    props.form.setValidateFn(this.validate)

    this.state = {
      verifying: false,
      fetching: true,
      fetchingNotes: false,
      calcing: true,
      calcingPrev: false,
      calcingNext: false,
      calcingReset: false,
      calcingPrincipal: false,
      activeNotes: props.activeNotes,
    }

    if (props.activeNotes.length) setTimeout(props.openActiveNotesModal)
    else if (props.coverCount > 0) props.openError(translateLKM('MSG_OPER_MAY_EXIST'))

    let ratePromise = Promise.resolve()
    const cashAccount = findCashAccountByID(this.props.CashAccounts, CashAccountID)
    const cashCCY = cashAccount ? cashAccount.CCY : undefined
    if (cashCCY && cashCCY !== this.loan.ISO) {
      // ratePromise = Order.orderRate({ OperTypeID: 3, NodeID: this.props.NodeID }).then(({ Data }) => {
      //   this.rates = Data

      //   const ccyRate = this.rates.find((r) => r.CCY === cashCCY && r.CCY2 === this.loan.ISO)
      //   if (ccyRate) {
      //     let rate = parseFloat(ccyRate.RateSell)
      //     this.realRate = rate

      //     rate = Math.round(rate * 10000) / 10000
      //     this.setState({ rate })
      //   }
      // })

      //UPDATED API REQUEST rate_view action: 'live'
      this.props.getOrderRate({ OperTypeID: 3, NodeID: this.props.NodeID }).then((response) => {
        this.rates = response.payload

        const ccyRate = this.rates.find((r) => r.CCY === cashCCY && r.CCY2 === this.loan.ISO)
        if (ccyRate) {
          let rate = parseFloat(ccyRate.RateSell)
          this.realRate = rate

          rate = Math.round(rate * 10000) / 10000
          this.setState({ rate })
        }
      })
    }

    ratePromise
      .then(() => this.calc())
      .then(() => this.calc())
      .then(() => {
        this.setState({ fetching: false })

        props.form.changeValues({
          Prolongate: !(
            LKDate.from(props.form.values.CoverDate) < LKDate.from(props.OpenDayStr) ||
            LKDate.from(this.loan.DisburseDate).instance.isSame(LKDate.from(props.form.values.CoverDate).instance) ||
            (this.calced && this.calced.IsRescheduled_Calced === 1)
          ),
        })
      })
  }

  printOptions = [
    { value: '1', label: translate('rb_print') },
    { value: '2', label: translate('rb_preview') },
    { value: '3', label: translate('rb_showdetails') },
  ]

  componentDidMount() {
    if (!this.props.CanViewEntries) {
      const data = Storage.get('loanCover')
      Storage.set('loanCover', {
        ...data,
        print: false,
      })
      this.props.form.changeValues({ print: false })
    }

    this.loadData()
  }

  loadData = async () => {
    const isIndivid = this.client.ClientTypeID.toString() === '1'

    if (isIndivid) {
      const [cashDocsResult, clientLinkedFilesResult] = await Promise.all([
        isIndivid
          ? this.props.loadClientCashDocs({
              clientId: this.client.ID,
              clientHash: this.client.HashSum_ClientID_,
            })
          : this.props.loadClientDelegateCashDocs({
              clientId: this.client.ID,
              clientHash: this.client.HashSum_ClientID_,
            }),
        this.props.loadClientLinkedFiles({
          clientId: this.client.ID,
          clientHash: this.client.HashSum_ClientID_,
        }),
      ])

      const cashDocsSearchKey = isIndivid ? 'DFDoc' : 'CashOper'
      const IDDoc = find(cashDocsResult.payload, [cashDocsSearchKey, 1]) || {}
      this.iddoc = IDDoc
      this.props.assignEntryDetails({
        IDDoc,
        Delegate: IDDoc,
        LinkedFiles: clientLinkedFilesResult.payload,
      })
    } else {
      const delegatesCashDocsResult = await this.props.loadClientDelegateCashDocs({
        clientId: this.client.ID,
        clientHash: this.client.HashSum_ClientID_,
      })

      const deldoc = find(delegatesCashDocsResult.payload, ['CashOper', 1])

      if (!deldoc) {
        return
      }

      const [clientDetailsResult, clientCashDocsResult, clientLinkedFilesResult] = await Promise.all([
        this.props.loadClientDetails({
          clientId: deldoc.RLClientID,
          clientHash: deldoc.HashSum_RLClientID_,
        }),
        this.props.loadClientCashDocs({
          clientId: deldoc.RLClientID,
          clientHash: deldoc.HashSum_RLClientID_,
        }),
        this.props.loadClientLinkedFiles({
          clientId: deldoc.RLClientID,
          clientHash: deldoc.HashSum_RLClientID_,
        }),
      ])

      const IDDoc = find(clientCashDocsResult.payload, ['ID', deldoc.IDDocID])
      this.iddoc = IDDoc

      const entryDetails = {
        IDDoc,
      }

      if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
        this.delegate = clientDetailsResult.payload
        entryDetails.Delegate = clientDetailsResult.payload
      }

      if (loadClientLinkedFiles.fulfilled.match(clientLinkedFilesResult)) {
        entryDetails.LinkedFiles = clientLinkedFilesResult.payload
      }

      this.props.assignEntryDetails(entryDetails)
    }
  }

  // loadActiveNotes = async () => {
  //   try {
  //     this.setState({ fetchingNotes: true })

  //     const { Data: activeNotes } = await Loan.fetchLoanNotes(this.props.params.ID, this.props.params.hash)

  //     this.setState({ fetchingNotes: false, activeNotes }, this.props.openActiveNotesModal)
  //   } catch (e) {
  //     this.props.openError(e.Error.Message || e.Error.Text)
  //   }
  // }

  totalCalced = 0
  calced = {}
  invoiceData = {}

  calcPrev = () => {
    this.principaled = false
    this.fulled = false
    this.refreshed = false
    this.nexted = false
    this.preved = true

    this.setState({ calcingPrev: true })

    return this.calcBase()
      .then(() => this.calcBase())
      .then(() => this.setState({ calcingPrev: false }))
  }

  calcNext = () => {
    this.principaled = false
    this.fulled = false
    this.refreshed = false
    this.nexted = true
    this.preved = false

    this.setState({ calcingNext: true })

    return this.calcBase()
      .then(() => this.calcBase())
      .finally(() => this.setState({ calcingNext: false }))
  }

  calcReset = () => {
    this.principaled = false
    this.fulled = false
    this.refreshed = true
    this.nexted = false
    this.preved = false

    this.setState({ calcingReset: true })

    return this.calcBase()
      .then(() => this.calcBase())
      .finally(() => this.setState({ calcingReset: false }))
  }

  calcPrincipal = () => {
    this.principaled = true
    this.fulled = false
    this.refreshed = false
    this.nexted = false
    this.preved = false

    this.setState({ calcingPrincipal: true })

    return this.calcBase()
      .then(() => this.calcBase())
      .finally(() => this.setState({ calcingPrincipal: false }))
  }

  calcFull = () => {
    this.principaled = false
    this.fulled = true
    this.refreshed = false
    this.nexted = false
    this.preved = false

    this.setState({ calcingFull: true })

    return this.calcBase().finally(() => this.setState({ calcingFull: false }))
  }

  calc = () => {
    this.refreshed = false
    this.nexted = false
    this.preved = false

    this.setState({ calcing: true })

    return this.calcBase().finally(() => this.setState({ calcing: false }))
  }

  clearTimer = () => {
    if (this.timer) {
      this.setState({ calcing: false })

      clearTimeout(this.timer)
      delete this.timer
    }
  }

  calcDelay = (recalc = false) => {
    this.clearTimer()

    this.setState({ calcing: true })

    this.timer = setTimeout(() => {
      this.calc().then(() => {
        if (recalc) return this.calc()
      })

      delete this.timer
    }, 1500)
  }

  calcBase = () => {
    const { ID, hash } = this.props.params

    const { form } = this.props

    const {
      CalcDate,
      GROSS_Cover,
      GROSS_Cover_EQ,

      Auto,

      SelectPrincipal,
      SelectInterestAccrued,
      SelectInterestScheduled,
      SelectPenaltyPri,
      SelectPenaltyInt,
      SelectProcFee,
      SelectInsurance,
      SelectUCLC,
      SelectAdvFee,

      Interest_Corr,
      PenaltyPri_Corr,
      PenaltyInt_Corr,
      ProcFee_Corr,
      Insurance_Corr,
      UCLC_Corr,

      FreezePrincipal,
      FreezeInterest,
      FreezePenaltyPri,
      FreezePenaltyInt,
      FreezeProcFee,
      FreezeInsurance,
      FreezeUCLC,
      FreezeAdvFee,
      CashAccountID,
      Principal_Cover,
      Interest_Cover,
      PenaltyPri_Cover,
      PenaltyInt_Cover,
      ProcFee_Cover,
      Insurance_Cover,
      UCLC_Cover,
      AdvFee_Cover,
    } = form.values

    const cashAccount = findCashAccountByID(this.props.CashAccounts, CashAccountID)

    const requestBody = {
      EventTypeID:
        (this.refreshed && '0') ||
        ((this.grossTouched || this.balanceClicked) && 1) ||
        (this.fulled && 2) ||
        (this.principaled && 3) ||
        ((this.nexted || this.preved) && 4) ||
        undefined,
      Nominal_Accent:
        (this.grossTouched && ((this.grossCoverChanged && 1) || (this.grossCoverEQChanged && '0'))) || undefined,
      CCYCommrate: this.realRate,
      LoanID: ID,
      HashSum_LoanID_: hash,
      CalcDate,
      GROSS_Cover: ((this.grossTouched || this.balanceClicked) && GROSS_Cover) || undefined,
      GROSS_Cover_EQ: ((this.grossTouched || this.balanceClicked) && GROSS_Cover_EQ) || undefined,

      chk_Select: `${+SelectPrincipal}${+SelectInterestAccrued}${+SelectInterestScheduled}${+SelectPenaltyPri}${+SelectPenaltyInt}${+SelectProcFee}${+SelectInsurance}${+SelectUCLC}${+SelectAdvFee}`,
      Interest_Corr,
      PenaltyPri_Corr,
      PenaltyInt_Corr,
      ProcFee_Corr,
      Insurance_Corr,
      UCLC_Corr,

      chk_Freeze: `${+FreezePrincipal}${+FreezeInterest}${+FreezePenaltyPri}${+FreezePenaltyInt}${+FreezeProcFee}${+FreezeInsurance}${+FreezeUCLC}${+FreezeAdvFee}`,
      Principal_Cover: (FreezePrincipal && Principal_Cover) || (this.fulled && this.calced.OSBalance) || undefined,
      Interest_Cover: FreezeInterest ? Interest_Cover : undefined,
      PenaltyPri_Cover: FreezePenaltyPri ? PenaltyPri_Cover : undefined,
      PenaltyInt_Cover: FreezePenaltyInt ? PenaltyInt_Cover : undefined,
      ProcFee_Cover: FreezeProcFee ? ProcFee_Cover : undefined,
      Insurance_Cover: FreezeInsurance ? Insurance_Cover : undefined,
      UCLC_Cover: FreezeUCLC ? UCLC_Cover : undefined,
      AdvFee_Cover: FreezeAdvFee ? AdvFee_Cover : undefined,
      CashAccountID,
      HashSum_CashAccountID_: cashAccount ? cashAccount.HashSum_AccountIDLoanID_ : undefined,
    }

    // return Loan.cover({
    //   params: { action: 'calc' },
    //   body: requestBody,
    // })
    //   .then(({ Data: data }) => {

    //   })
    //   .catch((e) => {
    //     this.props.openError(e && e.Error && translateLKM(e.Error.Text || e.Error.Message))
    //   })

    //UPDATED API REQUEST loan_cover_api action: 'calc'
    return this.props
      .loanCover({
        action: 'calc',
        ...requestBody,
      })
      .then((response) => {
        if (!loanCover.fulfilled.match(response)) {
          this.props.openError(translateLKM(response.payload))
        }

        const data = response.payload

        this.calced = data
        this.invoiceData = {
          CalcDate: LKDate.from(data.CalcDate).toString(),
          PrincipalDue: data.PrincipalDue_Calced,
          InterestAccrued: data.InterestAccrued_Calced,
          InterestScheduled: data.InterestScheduled_Calced,
          PenaltyPri: data.PenaltyPri_Calced,
          PenaltyInt: data.PenaltyInt_Calced,
          UCLC: data.UCLC_Calced,
          ProcFee: data.ProcFee_Calced,
          AdvancedFee: data.AdvFee_Calced,
          NextScheduleDate: LKDate.from(data.NextScheduleDate).toString(),
          PreviousScheduleDate: LKDate.from(data.PreviousScheduleDate).toString(),
          OSBalance: data.OSBalance,
          LoanCCY: this.loan.ISO,
        }
        const selects = {
          SelectInterestScheduled,
          SelectInterestAccrued,

          ...((Auto || this.props.InterestPriority !== '3') &&
          ['1', '3'].includes(this.props.InterestPriority) &&
          this.loan.ProductType === 4
            ? {
                SelectInterestScheduled: false,
                SelectInterestAccrued: true,
              }
            : {}),

          ...(['4', '5'].includes(this.props.InterestPriority) &&
          (this.loan.ProductType === 4 || this.calced.InterestScheduled_Calced <= 0)
            ? {
                SelectInterestScheduled: false,
                SelectInterestAccrued: true,
              }
            : {}),

          ...(['4', '5'].includes(this.props.InterestPriority) && this.calced.OVDDays_PIA > 0
            ? {
                SelectInterestScheduled: true,
                SelectInterestAccrued: false,
              }
            : {}),

          ...(['4', '5'].includes(this.props.InterestPriority) && this.calced.OVDDays_PIA === 0
            ? {
                SelectInterestScheduled: false,
                SelectInterestAccrued: true,
              }
            : {}),

          ...(['4', '5'].includes(this.props.InterestPriority) &&
          this.loan.ProductType === 4 &&
          this.calced.OVDDays_PIA > 0
            ? {
                SelectInterestScheduled: false,
                SelectInterestAccrued: true,
              }
            : {}),

          ...(this.fulled ? { SelectInterestScheduled: false, SelectInterestAccrued: true } : {}),
        }

        if (this.calced && this.calced.IsRescheduled_Calced === 1) {
          selects.Prolongate = false
        }

        const interestCalced =
          (selects.SelectInterestAccrued ? Math.max(this.calced.InterestAccrued_Calced, 0) : 0) +
          (selects.SelectInterestScheduled ? Math.max(this.calced.InterestScheduled_Calced, 0) : 0)

        const principalCalced = SelectPrincipal ? Math.max(this.calced.PrincipalDue_Calced, 0) : 0
        const penaltyPriCalced = SelectPenaltyPri ? Math.max(this.calced.PenaltyPri_Calced, 0) : 0
        const penaltyIntCalced = SelectPenaltyInt ? Math.max(this.calced.PenaltyInt_Calced, 0) : 0
        const procFeeCalced = SelectProcFee ? Math.max(this.calced.ProcFee_Calced, 0) : 0
        const insuranceCalced = SelectInsurance ? Math.max(this.calced.Insurance_Calced, 0) : 0
        const uclcCalced = SelectUCLC ? Math.max(this.calced.UCLC_Calced, 0) : 0
        const advFeeCalced = SelectAdvFee ? Math.max(this.calced.AdvFee_Calced, 0) : 0

        this.totalCalced =
          principalCalced +
          interestCalced +
          penaltyPriCalced +
          penaltyIntCalced +
          procFeeCalced +
          insuranceCalced +
          uclcCalced +
          advFeeCalced

        const principalCover = this.calced.Principal_Cover
        const interestCover = this.calced.Interest_Cover
        const penaltyPriCover = this.calced.PenaltyPri_Cover
        const penaltyIntCover = this.calced.PenaltyInt_Cover
        const procFeeCover = this.calced.ProcFee_Cover
        const insuranceCover = this.calced.Insurance_Cover
        const uclcCover = this.calced.UCLC_Cover
        const advFeeCover = this.calced.AdvFee_Cover

        const Principal = principalCover
        const Interest = interestCover
        const PenaltyPri = penaltyPriCover
        const PenaltyInt = penaltyIntCover
        const ProcFee = procFeeCover
        const Insurance = insuranceCover
        const UCLC = uclcCover
        const AdvFee = advFeeCover

        this.props.form.changeValues({
          CalcDate,
          Interest_Corr: this.calced.Interest_Corr,
          PenaltyPri_Corr: this.calced.PenaltyPri_Corr,
          PenaltyInt_Corr: this.calced.PenaltyInt_Corr,
          ProcFee_Corr: this.calced.ProcFee_Corr,
          Insurance_Corr: this.calced.Insurance_Corr,
          UCLC_Corr: this.calced.UCLC_Corr,

          Principal_Cover: Principal,
          Interest_Cover: Interest,
          PenaltyPri_Cover: PenaltyPri,
          PenaltyInt_Cover: PenaltyInt,
          ProcFee_Cover: ProcFee,
          Insurance_Cover: Insurance,
          UCLC_Cover: UCLC,
          AdvFee_Cover: AdvFee,
          GROSS_Cover: this.calced.GROSS_Cover,
          GROSS_Cover_EQ: this.calced.GROSS_Cover_EQ,
          ...selects,
        })
      })
  }

  validate = (values) => {
    const prolongDate = LKDate.from(values.ProlongateNextPaymentDate).instance

    const openDay = LKDate.from(this.props.OpenDayStr).instance

    return {
      ProlongateNextPaymentDate:
        this.loan.ProductType !== 4 ||
        !values.Prolongate ||
        !values.ProlongateNextPaymentDate ||
        (values.ProlongateNextPaymentDate && prolongDate > openDay)
          ? undefined
          : `> ${this.props.OpenDayStr}`,
    }
  }

  filterServices = (ProviderID) => {
    this.services = this.allServices
      .filter((s) => s.SPID === ProviderID)
      .map((s) => ({
        value: s.ID,
        text: s.Description,
      }))
  }

  isResubmit = false

  submit = async (values) => {
    try {
      const { IDDoc } = this.props.entryDetails

      if (!this.isResubmit) {
        const { entryDetails } = this.props

        const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = (
          await this.props.beforeLoanCover({
            AMLOperTypeID: 30,
            OperTypeID: values.CashOrder ? 3 : undefined,
            LoanID: this.props.params.ID,
            HashSum_LoanID_: this.props.params.hash,
            ClientID: values.CashOrder ? entryDetails.clientID : this.loan.ClientID,
            HashSum_ClientID_: values.CashOrder ? entryDetails.clientHash : this.loan.HashSum_ClientID_,
            Amount: values.GROSS_Cover,
            CCY: this.loan.ISO,
            IDDocID: IDDoc && IDDoc.ID,
            HashSum_IDDocID_: IDDoc && IDDoc.HashSum_IDDocID_,
          })
        ).payload

        this.session = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }

        if (ErrorLevel === 150 || ErrorLevel === 200) {
          const { payload: Data } = await this.props.eventView({ WHLSessionID, HashSum_WHLSessionID_ })

          this.eventData = Data

          this.props.openModal({
            name: ErrorLevel === 150 ? 'ClientValidationResultsConfirm' : 'ClientValidationResults',
            Data,
            ErrorLevel,
          })

          return Promise.reject()
        }
      } else {
        this.isResubmit = false
      }

      let RateSell
      let RateBuy
      const ccyAccount = findCashAccountByID(this.props.CashAccounts, values.CashAccountID)
      const CCY2 = this.props.loan.ISO
      if (ccyAccount && ccyAccount.CCY !== CCY2) {
        const { CCY } = ccyAccount
        RateSell = this.props.CCYCommercialRates.find((rate) => CCY === rate.CCY && rate.CCY2 === CCY2).RateSell
        RateBuy = this.props.CCYCommercialRates.find((rate) => CCY === rate.CCY2 && CCY2 === rate.CCY).RateBuy
      } else {
        RateSell = 0
        RateBuy = 0
      }

      const params = {
        LoanID: this.props.params.ID,
        HashSum_LoanID_: this.props.params.hash,
        CalcDate: values.CalcDate,
        CoverDate: values.CoverDate,
        AccountID: values.AccountID,
        HashSum_AccountIDLoanID_: this.accounts.find((a) => a.ID === values.AccountID).HashSum_AccountIDLoanID_,
        CashAuth: +values.CashAuth,
        GROSS_Cover: values.GROSS_Cover,
        GROSS_Cover_EQ: values.GROSS_Cover_EQ,
        chk_Select: `${+values.SelectPrincipal}${+values.SelectInterestAccrued}${+values.SelectInterestScheduled}${+values.SelectPenaltyPri}${+values.SelectPenaltyInt}${+values.SelectProcFee}${+values.SelectInsurance}${+values.SelectUCLC}${+values.SelectAdvFee}`,
        chk_Freeze: `${+values.FreezePrincipal}${+values.FreezeInterest}${+values.FreezePenaltyPri}${+values.FreezePenaltyInt}${+values.FreezeProcFee}${+values.FreezeInsurance}${+values.FreezeUCLC}${+values.FreezeAdvFee}`,
        Interest_Corr: values.Interest_Corr,
        PenaltyPri_Corr: values.PenaltyPri_Corr,
        PenaltyInt_Corr: values.PenaltyInt_Corr,
        ProcFee_Corr: values.ProcFee_Corr,
        Insurance_Corr: values.Insurance_Corr,
        UCLC_Corr: values.UCLC_Corr,
        Principal_Cover: values.Principal_Cover,
        Interest_Cover: values.Interest_Cover,
        PenaltyPri_Cover: values.PenaltyPri_Cover,
        PenaltyInt_Cover: values.PenaltyInt_Cover,
        ProcFee_Cover: values.ProcFee_Cover,
        Insurance_Cover: values.Insurance_Cover,
        UCLC_Cover: values.UCLC_Cover,
        AdvFee_Cover: values.AdvFee_Cover,
        Rate1: RateSell,
        Rate2: RateBuy,
      }

      if (this.loan.ProductType === 4) {
        params.Prolongate = +values.Prolongate
        params.ProlongateNextPaymentDate = values.ProlongateNextPaymentDate
      }

      params.OpCodeID = values.OpCodeID
      params.Comment = values.Comment

      if (values.CashOrder) {
        const cashAccount = findCashAccountByID(this.props.CashAccounts, values.CashAccountID)

        const diffCCY = this.loan.ISO !== cashAccount.CCY

        // checking limits
        if (this.requireClient(values, this.loan.ISO) && !this.props.entryDetails.clientIsChosen) {
          this.props.openError(translateLKM('ERR_REGISTER_CLIENT'))
          return Promise.reject()
        }

        // check if ID Copy file upload is required
        if (this.requireIDCopy(values, this.loan.ISO)) {
          const clientLinkedFilesResult = await this.props.loadClientLinkedFiles({
            clientId: this.props.entryDetails.clientID,
            clientHash: this.props.entryDetails.clientHash,
          })

          const files = clientLinkedFilesResult.payload

          if (files.length === 0) {
            this.props.openInfo(translateLKM('ERR_IDCOPY_REQUIRED_FOR_CONV'), this.props.openClientFiles)

            return Promise.reject()
          }
        }

        if (diffCCY) {
          // in case of conversion we pass initial default cash account
          const initialCashAccount = this.props.CashAccounts.find((a) => a.CCY === this.loan.ISO)
          params.CashAccountID = initialCashAccount.ID
          params.HashSum_CashAccountID_ = initialCashAccount.HashSum_AccountIDLoanID_

          // in case of conversion we pass selected cash account as conv account
          params.ConvAmount = values.GROSS_Cover_EQ
          params.ConvAccountID = cashAccount.ID
          params.HashSum_ConvAccountID_ = cashAccount.HashSum_AccountIDLoanID_
        } else {
          params.CashAccountID = cashAccount.ID
          params.HashSum_CashAccountID_ = cashAccount.HashSum_AccountIDLoanID_
        }

        params.OpCodeID = values.OpCodeID
        params.Comment = values.Comment
      }

      const {
        Client: { ID: clientId, HashSum_ClientID_: hashSum_ClientID },
        Delegate,
      } = this.props.entryDetails

      if (IDDoc) {
        params.IDDocID = IDDoc.ID
        params.HashSum_IDDocID_ = IDDoc.HashSum_IDDocID_
      }

      if (this.client.ClientTypeID.toString() === '1' || !Delegate) {
        params.ClientID = clientId
        params.HashSum_ClientID_ = hashSum_ClientID
      } else {
        params.ClientID = Delegate.ID
        params.HashSum_ClientID_ = Delegate.HashSum_ClientID_

        params.Company_ClientID = this.client.ID
        params.HashSum_Company_ClientID_ = this.client.HashSum_ClientID_
      }

      // const { Data } = await Loan.cover({
      //   params: { action: 'cover' },
      //   body: {
      //     ...params,
      //     WHLSessionID: this.session.WHLSessionID,
      //     HashSum_WHLSessionID_: this.session.HashSum_WHLSessionID_,
      //   },
      // })

      //UPDATED API REQUEST loan_cover_api action: 'cover'
      const loanCoverResponse = await this.props.loanCover({
        action: 'cover',
        ...params,
        WHLSessionID: this.session.WHLSessionID,
        HashSum_WHLSessionID_: this.session.HashSum_WHLSessionID_,
      })

      if (!loanCover.fulfilled.match(loanCoverResponse)) {
        throw { Error: { Message: loanCoverResponse.payload } }
      }

      const Data = loanCoverResponse.payload

      if (this.props.onSuccess) this.props.onSuccess()

      if (values.CashOrder && values.print) {
        printReport({
          OperTypeID: 3,
          page: 'printcashin',
          printOption: values.printOption,
          EntryID: Data.Cash_EntryID,
          HashSum_EntryID_: Data.HashSum_Cash_EntryID_,
          isCheckLoan: true,
          history: this.props.history,
          dispatch: this.props.dispatch,
        }).then(async () => {
          if (Data.Conv_OID) {
            // wait for window to open in taskbar
            if (values.printOption === '3') await new Promise((resolve) => setTimeout(resolve, 1000))

            await printReport({
              OperTypeID: 7,
              page: 'printconvcash',
              printOption: values.printOption,
              EntryID: Data.Conv_EntryID,
              HashSum_EntryID_: Data.HashSum_Conv_EntryID_,
              OID: Data.Conv_OID,
              HashSum_OID_: Data.HashSum_Conv_OID_,
              isCheckLoan: true,
              history: this.props.history,
              dispatch: this.props.dispatch,
            })
          }
        })
      }

      this.props.closeModal()

      if (Data.Closed === 1) {
        const { ID, hash } = this.props.params

        // Loan.details({ ID, hash, page: 'collaterals' }).then(({ Data: collaterals }) => {
        //   this.props.openCloseCheck({
        //     ID,
        //     hash,
        //     RevolvingID: this.loan.RevolvingID,
        //     Location: collaterals && collaterals.length && collaterals[0].Location,
        //   })
        // })
        //UPDATED API REQUEST loan_view_api page: collaterals
        this.props
          .loanView({
            LoanID: ID,
            HashSum_LoanID_: hash,
            page: 'collaterals',
          })
          .then((response) => {
            if (!loanView.fulfilled.match(response)) {
              return
            }
            const collaterals = response.payload
            this.props.openCloseCheck({
              ID,
              hash,
              RevolvingID: this.loan.RevolvingID,
              Location: collaterals && collaterals.length && collaterals[0].Location,
            })
          })
      }
    } catch (e) {
      this.props.openError(
        e.Error
          ? translateLKM(e.Error.Message || e.Error.Text) ||
              (
                e.Error.FailedFields &&
                e.Error.FailedFields.length &&
                e.Error.FailedFields.map((f) => `${f.FName} - ${f.Comment}`)
              ).join('\n') ||
              e.Error.Code
          : translateLKM('HINT_ERR_TITLE'),
      )

      console.error(e) // eslint-disable-line no-console
    }
  }

  handleSubmit = () => {
    if (this.props.form.values.CashOrder && !this.props.CashAccounts.length) {
      this.props.openError(translateWeb('NO_CASH_ACC'))
      return
    }

    this.props.form.handleSubmit(this.submit)
  }

  handleBalanceClick = () => {
    const { form } = this.props
    const account = this.accounts.find((a) => a.ID === form.values.AccountID)
    if (account.Balance > 0) {
      this.balanceClicked = true
      form.changeValues({ GROSS_Cover: account.Balance }, () => this.calculateAmounts(false, true))
    }
  }

  grossTouched = false

  balanceClicked = false

  principaled = false

  nexted = false

  preved = false

  handleChanged = (values, newValues) => {
    this.clearTimer()

    if ('PenaltyPri_Corr' in newValues && newValues['PenaltyPri_Corr'] > this.calced['PenaltyPri_Calced']) {
      this.props.openError(`${newValues['PenaltyPri_Corr']} - ცდება დასაშვებ ზღვარს`)
      this.calcPrev()
      return
    }

    if ('PenaltyInt_Corr' in newValues && newValues['PenaltyInt_Corr'] > this.calced['PenaltyInt_Calced']) {
      this.props.openError(`${newValues['PenaltyInt_Corr']} - ცდება დასაშვებ ზღვარს`)
      this.calcPrev()
      return
    }

    if ('ProcFee_Corr' in newValues && newValues['ProcFee_Corr'] > this.calced['ProcFee_Calced']) {
      this.props.openError(`${newValues['ProcFee_Corr']} - ცდება დასაშვებ ზღვარს`)
      this.calcPrev()
      return
    }

    if ('UCLC_Corr' in newValues && newValues['UCLC_Corr'] > this.calced['UCLC_Calced']) {
      this.props.openError(`${newValues['UCLC_Corr']} - ცდება დასაშვებ ზღვარს`)
      this.calcPrev()
      return
    }

    if ('Insurance_Corr' in newValues && newValues['Insurance_Corr'] > this.calced['Insurance_Calced']) {
      this.props.openError(`${newValues['Insurance_Corr']} - ცდება დასაშვებ ზღვარს`)
      this.calcPrev()
      return
    }

    if ('CalcDate' in newValues) this.balanceClicked = false

    const freeze = {}

    if ('SelectInterestAccrued' in newValues) freeze.SelectInterestScheduled = !values.SelectInterestAccrued
    if ('SelectInterestScheduled' in newValues) freeze.SelectInterestAccrued = !values.SelectInterestScheduled

    if ('Principal_Cover' in newValues) freeze.FreezePrincipal = true
    if ('Interest_Cover' in newValues) freeze.FreezeInterest = true
    if ('PenaltyPri_Cover' in newValues) freeze.FreezePenaltyPri = true
    if ('PenaltyInt_Cover' in newValues) freeze.FreezePenaltyInt = true
    if ('ProcFee_Cover' in newValues) freeze.FreezeProcFee = true
    if ('Insurance_Cover' in newValues) freeze.FreezeInsurance = true
    if ('UCLC_Cover' in newValues) freeze.FreezeUCLC = true
    if ('AdvFee_Cover' in newValues) freeze.FreezeAdvFee = true

    if ('SelectPrincipal' in newValues && !values.SelectPrincipal) {
      freeze.Principal_Cover = 0
    }

    if ('SelectPenaltyPri' in newValues) {
      freeze.FreezePenaltyPri = !values.SelectPenaltyPri
      freeze.PenaltyPri_Cover = 0
    }

    if ('SelectPenaltyInt' in newValues) {
      freeze.FreezePenaltyInt = !values.SelectPenaltyInt
      freeze.PenaltyInt_Cover = 0
    }

    if ('SelectProcFee' in newValues) {
      freeze.FreezeProcFee = !values.SelectProcFee
      freeze.ProcFee_Cover = 0
    }

    if ('SelectInsurance' in newValues) {
      freeze.FreezeInsurance = !values.SelectInsurance
      freeze.Insurance_Cover = 0
    }

    if ('SelectUCLC' in newValues) {
      freeze.FreezeUCLC = !values.SelectUCLC
      freeze.UCLC_Cover = 0
    }

    if ('SelectAdvFee' in newValues) {
      freeze.FreezeAdvFee = !values.SelectAdvFee
      freeze.AdvFee_Cover = 0
    }

    this.props.form.changeValues(freeze, () => this.calcDelay('CalcDate' in newValues))
  }

  handlePrev = () => {
    if (this.calced.PreviousScheduleDate === '1900-01-01 00:00:00') {
      this.props.openError(translateLKM('ERR_NOMORE_PAYMENTS'))
    } else {
      this.balanceClicked = false
      this.props.form.changeValues(
        { CalcDate: LKDate.from(this.calced.PreviousScheduleDate).toString() },
        this.calcPrev,
      )
    }
  }

  handleNext = () => {
    if (this.calced.NextScheduleDate === '1900-01-01 00:00:00') {
      this.props.openError(translateLKM('ERR_NOMORE_PAYMENTS'))
    } else {
      this.balanceClicked = false
      this.props.form.changeValues({ CalcDate: LKDate.from(this.calced.NextScheduleDate).toString() }, this.calcNext)
    }
  }

  handleClientDetails = ({
    Name,
    Surname,
    IDCardTypeID,
    CardNumber,
    OtherIDNumber,
    IDCardIssuerID,
    CitizenshipID,
    DOB,
    CityID,
    Address,
    IDCardRegDate,
    IDValidityDate,
    CellPhone,
    clientIsChosen,
    clientID,
    clientHash,
    clientType,
    Client: client,
    IDDoc,
    LinkedFiles,
    Delegate,
  }) => {
    this.props.assignEntryDetails({
      Name,
      Surname,
      IDCardTypeID,
      CardNumber,
      OtherIDNumber,
      IDCardIssuerID,
      CitizenshipID,
      DOB,
      CityID,
      Address,
      IDCardRegDate,
      IDValidityDate,
      CellPhone,
      clientIsChosen,
      clientID,
      clientHash,
      clientType,
      ClientType: clientType.toString(),
      Client: client,
      IDDoc,
      LinkedFiles,
      Delegate,
    })
  }

  handleComment = ({ Title }) => {
    this.props.form.changeValues({ Comment: Title })
  }

  handleCashAccountChanged = () => {
    if (!this.props.CashAccounts.length) return

    const cashCCY = findCashAccountByID(this.props.CashAccounts, this.props.form.values.CashAccountID).CCY

    if (cashCCY !== this.loan.ISO) {
      // Order.orderRate({ OperTypeID: 3, NodeID: this.props.NodeID }).then(({ Data }) => {
      //   this.rates = Data

      //   this.calculateAmounts(false, true)
      // })
      //UPDATED API REQUEST rate_view action: 'live'
      this.props.getOrderRate({ OperTypeID: 3, NodeID: this.props.NodeID }).then((response) => {
        this.rates = response.payload

        this.calculateAmounts(false, true)
      })
    } else {
      this.rate = 1
      this.realRate = 1

      if (this.grossTouched) {
        this.grossCoverChanged = true
        this.grossCoverEQChanged = false
      }

      this.calcDelay()
    }
  }

  calculateAmounts = (reverse, recalc) => {
    const { form } = this.props

    const cashAccount = findCashAccountByID(this.props.CashAccounts, form.values.CashAccountID)
    const CCY = cashAccount && cashAccount.CCY
    const { ISO } = this.loan

    if (cashAccount && CCY !== ISO) {
      this.grossCoverChanged = !reverse
      this.grossCoverEQChanged = reverse

      const ccyRate = this.rates.find((r) => r.CCY === CCY && r.CCY2 === ISO)
      if (ccyRate) {
        let rate = parseFloat(ccyRate.RateSell)

        if (recalc) this.calcDelay()

        this.realRate = rate

        rate = Math.round(rate * 10000) / 10000

        this.setState({ rate })
      }
    } else {
      form.changeValues({ GROSS_Cover_EQ: form.values.GROSS_Cover }, () => {
        if (recalc) this.calcDelay()
      })
    }
  }

  handleGrossCoverChanged = () => {
    this.clearTimer()

    this.principaled = false
    this.fulled = false
    this.refreshed = false
    this.nexted = false
    this.preved = false

    this.grossCoverChanged = true
    this.grossCoverEQChanged = false

    this.grossTouched = true
    this.calculateAmounts(false, true)
  }

  handleGrossCoverEQChanged = () => {
    this.clearTimer()

    this.principaled = false
    this.fulled = false
    this.refreshed = false
    this.nexted = false
    this.preved = false

    this.grossCoverChanged = false
    this.grossCoverEQChanged = true

    this.grossTouched = true
    this.calculateAmounts(true, true)
  }

  handleReset = () => {
    this.balanceClicked = false
    this.props.form.changeValues({ CalcDate: this.props.OpenDayStr }, this.calcReset)
  }

  handleActiveNotesClose = () => {
    if (this.props.coverCount > 0) this.props.openInfo(translateLKM('MSG_OPER_MAY_EXIST'))
  }

  handleProlongateChanged = () => {
    this.props.form.changeValues({ ProlongateNextPaymentDate: '' })
  }

  handlePrincipalCalc = () => {
    if (this.calced.NextScheduleDate === '1900-01-01 00:00:00') {
      this.props.openError(translateLKM('ERR_NOMORE_PAYMENTS'))
    } else {
      this.balanceClicked = false
      this.props.form.changeValues(
        { CalcDate: LKDate.from(this.calced.NextScheduleDate).toString() },
        this.calcPrincipal,
      )
    }
  }

  handleCoverDateChanged = () => {
    const values = {}

    const isPastDate = LKDate.from(this.props.form.values.CoverDate) < LKDate.from(this.props.OpenDayStr)

    values.Prolongate = !(
      isPastDate ||
      LKDate.from(this.loan.DisburseDate).instance.isSame(LKDate.from(this.props.form.values.CoverDate).instance) ||
      (this.calced && this.calced.IsRescheduled_Calced === 1)
    )

    if (isPastDate) values.CashOrder = false

    this.props.form.changeValues(values)
  }

  handleFullCover = () => {
    this.grossTouched = false
    this.grossCoverChanged = false
    this.grossCoverEQChanged = false
    this.balanceClicked = false

    this.props.form.changeValues(
      { Prolongate: false, SelectInterestScheduled: false, SelectInterestAccrued: true },
      this.calcFull,
    )
  }

  convertAmount = (amount, iso) => parseFloat(amount) * this.props.CCYOfficalRates.find((r) => r.CCY === iso).OffRate

  requireClient = (values, loanISO) => {
    const isLocalCCY = loanISO === this.props.LocalCCY
    const grossCoverEq = !isLocalCCY && this.convertAmount(values.GROSS_Cover, loanISO)

    return (
      (isLocalCCY && parseFloat(values.GROSS_Cover) >= parseFloat(this.props.Limit_CashOper_Req)) ||
      (!isLocalCCY &&
        (grossCoverEq >= parseFloat(this.props.Limit_CashOper_Req) ||
          grossCoverEq >= parseFloat(this.props.Limit_Conv_Req) ||
          grossCoverEq >= parseFloat(this.props.Limit_Conv_Req_IDCopy)))
    )
  }

  requireIDCopy = (values, loanISO) =>
    loanISO !== this.props.LocalCCY &&
    this.convertAmount(values.GROSS_Cover, loanISO) >= parseFloat(this.props.Limit_Conv_Req_IDCopy)

  session = {}

  eventParams = {}

  eventData = undefined

  onVerify = () => {
    const { GROSS_Cover, CashOrder } = this.props.form.values
    const {
      entryDetails,
      params: { ID, hash },
    } = this.props

    const { IDDoc } = entryDetails

    const apiParams = {
      AMLOperTypeID: 30,
      OperTypeID: CashOrder ? 3 : undefined,
      LoanID: ID,
      HashSum_LoanID_: hash,
      ClientID: CashOrder ? entryDetails.clientID : this.loan.ClientID,
      HashSum_ClientID_: CashOrder ? entryDetails.clientHash : this.loan.HashSum_ClientID_,
      Amount: GROSS_Cover,
      CCY: this.loan.ISO,
      IDDocID: IDDoc && IDDoc.ID,
      HashSum_IDDocID_: IDDoc && IDDoc.HashSum_IDDocID_,
    }

    if (this.session.WHLSessionID && isEqual(this.eventParams, apiParams)) {
      this.props.openModal({
        name: 'ClientValidationResults',
        Data: this.eventData,
        ErrorLevel: this.session.ErrorLevel,
      })
      return
    }

    this.setState({ verifying: true })

    this.props
      .beforeLoanCover(apiParams)
      .then((result) => {
        const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = result.payload

        this.session = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }
        this.eventParams = apiParams

        return this.props.eventView({ WHLSessionID, HashSum_WHLSessionID_ }).then((eventResult) => {
          if (!eventView.fulfilled.match(eventResult)) {
            return
          }

          const Data = eventResult.payload

          this.eventData = Data

          this.props.openModal({ name: 'ClientValidationResults', Data, ErrorLevel })
        })
      })
      .catch((e) => {
        this.props.openError(translateLKM((e.Error && (e.Error.Message || e.Error.Text)) || 'HINT_ERR_TITLE'))
      })
      .finally(() => {
        this.setState({ verifying: false })
      })
  }

  render() {
    const { modalInstanceName, form, OpenDayStr, CanCorrect, CanAllocate, entryDetails, params } = this.props

    const { values, submitting } = form
    const { ID: LoanID, hash: LoanHash } = params

    const { Balance } = (this.accounts && this.accounts.find((a) => a.ID === values.AccountID)) || 0

    const { fetching, calcing, rate, verifying } = this.state

    const cashAccount = findCashAccountByID(this.props.CashAccounts, values.CashAccountID)
    const cashCCY = cashAccount && cashAccount.CCY
    const diffCCY = cashAccount && cashCCY !== this.loan.ISO

    const disableHandfill = this.requireClient(values, this.loan.ISO)

    let title = `${translate('frm_loan_cover')}`

    if (this.loan)
      title += ` - ${this.loan.FullName} - ${this.loan.ISO} - ${this.loan.AgreementNo} / ${this.loan.ManagerName}`

    const isIndivid = this.client.ClientTypeID.toString() === '1'

    return (
      <>
        <ActiveNotesModal onClose={this.handleActiveNotesClose} data={{ ...this.loan, ...this.props.params }} />

        <ClientValidationResults name="ClientValidationResultsConfirm" onClose={this.props.openMatrixConfirmation} />

        <LKModal.Confirmation
          name="CONFIRM_MATRIX_WARNING"
          onConfirm={() => {
            this.isResubmit = true
            this.handleSubmit()
          }}
        />

        <LKModal
          icon="cover"
          name={modalInstanceName}
          heading={title}
          loading={fetching}
          size="lg"
          footer={
            <LKModal.Footer
              actions={
                <>
                  <LKPrintButton
                    type={LKPrintButtonConstants.types.loan}
                    name={translate('cmd_print_invoice')}
                    ID={LoanID}
                    hash={LoanHash}
                    page="printloancoverinvoice"
                    body={{ InvoiceData: JSON.stringify(this.invoiceData) }}
                    disabled={!this.props.CanPrintInvoice}
                    leftward
                    direct
                    upward
                  />

                  {this.loan.ProductType === 4 && (
                    <>
                      <FormField
                        type="checkbox"
                        name="Prolongate"
                        form={form}
                        label={translate('chk_auto_prolong')}
                        disabled={
                          LKDate.from(values.CoverDate) < LKDate.from(OpenDayStr) ||
                          LKDate.from(this.loan.DisburseDate).instance.isSame(LKDate.from(values.CoverDate).instance) ||
                          (this.calced && this.calced.IsRescheduled_Calced === 1)
                        }
                        onChanged={this.handleProlongateChanged}
                        autoWidth
                      />

                      {values.Prolongate && (
                        <DateFieldWrapper>
                          <FormField
                            type="date"
                            name="ProlongateNextPaymentDate"
                            form={form}
                            inputProps={{ style: { width: 120 } }}
                            autoWidth
                            upward
                          />
                        </DateFieldWrapper>
                      )}
                    </>
                  )}
                </>
              }
              sideActions={
                <>
                  <LKButton alias="amlCheckmark" loading={verifying} disabled={verifying} onClick={this.onVerify} />

                  <LKButton
                    alias="ok"
                    className="okay-button"
                    disabled={
                      calcing ||
                      submitting ||
                      (this.loan.ProductType !== 4 && !this.props.CanCoverOper) ||
                      (this.loan.ProductType === 4 && !this.props.CanCoverOperLMB)
                    }
                    loading={submitting}
                    onClick={this.handleSubmit}
                  >
                    {translate('cmd_finish')}
                  </LKButton>

                  <LKModal.CancelButton disabled={submitting} loading={submitting} text={translate('cmd_cancel')} />
                </>
              }
              info={
                <LoanCoverFooterInfoWrapper className="loan-cover__footer-info">
                  <span>
                    {this.calced &&
                      (this.calced.NextScheduleDate === '1900-01-01 00:00:00'
                        ? translate('lbl_stat4')
                        : `${translate('lbl_stat0')} - ${LKDate.from(this.calced.NextScheduleDate).toString()}`)}
                  </span>

                  <span>
                    {translate('lbl_stat1')} -{`${this.calced && this.calced.OSBalance} ${this.loan.ISO}`}
                  </span>

                  <span>
                    {this.calced &&
                      (this.calced.OVDDays_PIA > 0
                        ? `${translate('lbl_stat2')} - ${this.calced.OVDDays_PIA}`
                        : translate('lbl_stat3'))}
                  </span>
                </LoanCoverFooterInfoWrapper>
              }
            />
          }
        >
          <div className="u-padding-5">
            <div className="u-flex u-directionRow u-alignCenter" />

            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={3} className="u-flex u-directionRow u-alignCenter u-pullRight">
                    {translate('დაფარვა ანგარიშიდან')}
                  </Grid.Column>

                  <Grid.Column width={11} className="u-flex u-directionRow u-flexCenter">
                    <FormField type="select" form={form} name="AccountID" options={this.Accounts} flex />
                  </Grid.Column>

                  <Grid.Column
                    width={2}
                    className="u-flex u-directionRow u-alignCenter u-pullRigt"
                    onClick={this.handleBalanceClick}
                  >
                    <DataSegment>{Balance}</DataSegment>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column />

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-pullRight">
                    <FormField
                      type="number"
                      form={form}
                      name="GROSS_Cover"
                      onChanged={this.handleGrossCoverChanged}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column
                    width={1}
                    className="u-flex u-directionRow u-alignCenter"
                    style={{ color: colors.red, fontWeight: 'bold' }}
                  >
                    {this.loan.ISO}
                  </Grid.Column>

                  <Grid.Column width={5} className="u-flex u-directionRow u-alignCenter">
                    <LKCustomButton
                      alias="chip"
                      className="u-fluid"
                      onClick={this.calc}
                      disabled={calcing}
                      loading={calcing}
                    >
                      {translate('cmd_calc')}
                    </LKCustomButton>
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter text-green">
                    {translate('pan_correct_caption')}
                  </Grid.Column>

                  <Grid.Column width={4} className="u-flex u-directionRow u-flexCenter">
                    <Button className="u-fluid" style={{ height: 33, marginRight: 0 }}>
                      {translate('cmd_distribute')}
                    </Button>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={1} className="u-flex u-directionRow u-alignCenter u-pullRight">
                    {diffCCY && <DataSegment style={{ padding: '0.5em 0em', textAlign: 'center' }}>{rate}</DataSegment>}
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-pullRight">
                    {diffCCY && (
                      <FormField
                        type="number"
                        form={form}
                        className="input-red"
                        name="GROSS_Cover_EQ"
                        onChanged={this.handleGrossCoverEQChanged}
                        autoComplete="off"
                      />
                    )}
                  </Grid.Column>

                  <Grid.Column width={1} className="u-flex u-directionRow u-alignCenter">
                    {diffCCY && cashCCY}
                  </Grid.Column>

                  <Grid.Column width={5} className="u-flex u-directionRow u-alignCenter">
                    <LKCustomButton
                      alias="prev_big_double"
                      className="u-marginRight-10"
                      onClick={this.handlePrev}
                      disabled={this.state.calcingPrev}
                      loading={this.state.calcingPrev}
                    />

                    <FormField type="date" form={form} autoWidth name="CalcDate" onChanged={this.handleChanged} />

                    <LKCustomButton
                      alias="refresh"
                      className="u-marginLeft-10"
                      onClick={this.handleReset}
                      disabled={this.state.calcingReset}
                      loading={this.state.calcingReset}
                    />

                    <LKCustomButton
                      alias="next_big_double"
                      className="u-marginLeft-5"
                      onClick={this.handleNext}
                      disabled={this.state.calcingNext}
                      loading={this.state.calcingNext}
                    />

                    <LKCustomButton
                      alias="down_big"
                      className="u-marginLeft-5"
                      disabled={this.state.calcingFull}
                      loading={this.state.calcingFull}
                      onClick={this.handleFullCover}
                    />
                  </Grid.Column>

                  <Grid.Column width={5} />

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-pullRight">
                    <FormField
                      type="date"
                      form={form}
                      autoWidth
                      name="CoverDate"
                      right
                      onChanged={this.handleCoverDateChanged}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_principal_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectPrincipal"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter" style={borderBottom}>
                    {this.calced && this.calced.PrincipalDue_Calced}
                  </Grid.Column>

                  <Grid.Column className="u-textRight">
                    <LKCustomButton
                      alias="next_big"
                      onClick={this.handlePrincipalCalc}
                      disabled={this.state.calcingPrincipal}
                      loading={this.state.calcingPrincipal}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} />

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezePrincipal"
                      disabled={!CanAllocate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="Principal_Cover"
                      positive
                      disabled={!CanAllocate}
                      onChanged={this.handleChanged}
                      className={values.Principal_Cover < this.calced.PrincipalDue_Calced ? 'input-red' : 'input-green'}
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter text-green">
                    {!['1', '2'].includes(this.props.InterestPriority) && (
                      <FormField
                        type="checkbox"
                        form={form}
                        name="Auto"
                        label={translate('chk_optimal_allocation')}
                        onChanged={this.handleChanged}
                        disabled={['4', '5'].includes(this.props.InterestPriority)}
                      />
                    )}
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_interest_t')}
                  </Grid.Column>

                  <Grid.Column
                    width={2}
                    className="u-flex u-directionRow u-alignCenter u-spaceBetween"
                    style={borderBottom}
                  >
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectInterestScheduled"
                      onChanged={this.handleChanged}
                      disabled={
                        values.Auto ||
                        ['1', '2', '4', '5'].includes(this.props.InterestPriority) ||
                        !CanAllocate ||
                        !this.conditions.InterestRate
                      }
                    />
                    {this.calced && this.calced.InterestScheduled_Calced}
                  </Grid.Column>

                  <Grid.Column />

                  <Grid.Column
                    width={2}
                    className="u-flex u-directionRow u-alignCenter u-spaceBetween"
                    style={borderBottom}
                  >
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectInterestAccrued"
                      onChanged={this.handleChanged}
                      disabled={
                        values.Auto ||
                        ['1', '2', '4', '5'].includes(this.props.InterestPriority) ||
                        !CanAllocate ||
                        !this.conditions.InterestRate
                      }
                    />
                    {this.calced && this.calced.InterestAccrued_Calced}
                  </Grid.Column>

                  <Grid.Column width={1} />

                  <Grid.Column width={2}>
                    <FormField
                      type="number"
                      form={form}
                      name="Interest_Corr"
                      disabled={!CanCorrect}
                      className={!CanCorrect ? ' input-disabled' : ''}
                      onChanged={this.handleChanged}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezeInterest"
                      disabled={!CanAllocate || !this.conditions.InterestRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="Interest_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.InterestRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.Interest_Cover <
                        ((values.SelectInterestScheduled && this.calced.InterestScheduled_Calced) ||
                          (values.SelectInterestAccrued && this.calced.InterestAccrued_Calced))
                          ? 'input-red'
                          : 'input-green') + (!this.conditions.InterestRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_pen_pri_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectPenaltyPri"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate || !this.conditions.PenaltyPriRate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter" style={borderBottom}>
                    {this.calced && this.calced.PenaltyPri_Calced}
                  </Grid.Column>

                  <Grid.Column width={2} />

                  <Grid.Column width={2}>
                    <FormField
                      type="number"
                      form={form}
                      name="PenaltyPri_Corr"
                      onChanged={this.handleChanged}
                      className={!CanAllocate || !this.conditions.PenaltyPriRate ? ' input-disabled' : ''}
                      disabled={!CanAllocate || !this.conditions.PenaltyPriRate}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezePenaltyPri"
                      disabled={!CanAllocate || !this.conditions.PenaltyPriRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="PenaltyPri_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.PenaltyPriRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.PenaltyPri_Cover < this.calced.PenaltyPri_Calced ? 'input-red' : 'input-green') +
                        (!this.conditions.PenaltyPriRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_pen_int_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectPenaltyInt"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate || !this.conditions.PenaltyIntRate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter" style={borderBottom}>
                    {this.calced && this.calced.PenaltyInt_Calced}
                  </Grid.Column>

                  <Grid.Column width={2} />

                  <Grid.Column width={2}>
                    <FormField
                      type="number"
                      form={form}
                      name="PenaltyInt_Corr"
                      onChanged={this.handleChanged}
                      className={!CanAllocate || !this.conditions.PenaltyIntRate ? ' input-disabled' : ''}
                      disabled={!CanAllocate || !this.conditions.PenaltyIntRate}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezePenaltyInt"
                      disabled={!CanAllocate || !this.conditions.PenaltyIntRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="PenaltyInt_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.PenaltyIntRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.PenaltyInt_Cover < this.calced.PenaltyInt_Calced ? 'input-red' : 'input-green') +
                        (!this.conditions.PenaltyIntRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_procfee_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectProcFee"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate || !this.conditions.ProcFeeRate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter" style={borderBottom}>
                    {this.calced && this.calced.ProcFee_Calced}
                  </Grid.Column>

                  <Grid.Column width={2} />

                  <Grid.Column width={2}>
                    <FormField
                      type="number"
                      form={form}
                      name="ProcFee_Corr"
                      onChanged={this.handleChanged}
                      className={!CanAllocate || !this.conditions.ProcFeeRate ? ' input-disabled' : ''}
                      disabled={!CanAllocate || !this.conditions.ProcFeeRate}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezeProcFee"
                      disabled={!CanAllocate || !this.conditions.ProcFeeRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="ProcFee_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.ProcFeeRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.ProcFee_Cover < this.calced.ProcFee_Calced ? 'input-red' : 'input-green') +
                        (!this.conditions.ProcFeeRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translateAccLoanCover('lbl_insurance_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectInsurance"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate || !this.conditions.InsRate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter" style={borderBottom}>
                    {this.calced && this.calced.Insurance_Calced}
                  </Grid.Column>

                  <Grid.Column width={2} />

                  <Grid.Column width={2}>
                    <FormField
                      type="number"
                      form={form}
                      name="Insurance_Corr"
                      onChanged={this.handleChanged}
                      className={!CanAllocate || !this.conditions.InsRate ? ' input-disabled' : ''}
                      disabled={!CanAllocate || !this.conditions.InsRate}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezeInsurance"
                      disabled={!CanAllocate || !this.conditions.InsRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="Insurance_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.InsRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.Insurance_Cover < this.calced.Insurance_Calced ? 'input-red' : 'input-green') +
                        (!this.conditions.InsRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_uclc_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectUCLC"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate || !this.conditions.UCLCRate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter" style={borderBottom}>
                    {this.calced && this.calced.UCLC_Calced}
                  </Grid.Column>

                  <Grid.Column width={2} />

                  <Grid.Column width={2}>
                    <FormField
                      type="number"
                      form={form}
                      name="UCLC_Corr"
                      onChanged={this.handleChanged}
                      className={!CanAllocate || !this.conditions.UCLCRate ? ' input-disabled' : ''}
                      disabled={!CanAllocate || !this.conditions.UCLCRate}
                      autoComplete="off"
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezeUCLC"
                      disabled={!CanAllocate || !this.conditions.UCLCRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="UCLC_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.UCLCRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.UCLC_Cover < this.calced.UCLC_Calced ? 'input-red' : 'input-green') +
                        (!this.conditions.UCLCRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight text-green">
                    {translate('lbl_advfee_t')}
                  </Grid.Column>

                  <Grid.Column className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="SelectAdvFee"
                      onChanged={this.handleChanged}
                      disabled={!CanAllocate || !this.conditions.AdvFeeRate}
                    />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter">
                    {this.calced && this.calced.AdvFee_Calced}
                  </Grid.Column>

                  <Grid.Column width={4} />

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter">
                    <FormField
                      type="checkbox"
                      form={form}
                      name="FreezeAdvFee"
                      disabled={!CanAllocate || !this.conditions.AdvFeeRate}
                      onChanged={this.handleChanged}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                    <FormField
                      type="number"
                      form={form}
                      name="AdvFee_Cover"
                      positive
                      disabled={!CanAllocate || !this.conditions.AdvFeeRate}
                      onChanged={this.handleChanged}
                      className={
                        (values.AdvFee_Cover < this.calced.AdvFee_Calced ? 'input-red' : 'input-green') +
                        (!this.conditions.AdvFeeRate ? ' input-disabled' : '')
                      }
                      autoComplete="off"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Hr />

                <Grid.Row>
                  <Grid.Column
                    width={4}
                    className="u-flex u-directionRow u-flexCenter"
                    style={{ color: colors.red, fontWeight: 'bold' }}
                  >
                    {translate('lbl_total_t')}
                  </Grid.Column>

                  <Grid.Column
                    width={5}
                    className="u-flex u-directionRow u-flexCenter"
                    style={{ color: colors.red, fontWeight: 'bold' }}
                  >
                    {this.totalCalced.toFixed(2)}
                  </Grid.Column>

                  <Grid.Column width={3} />

                  <Grid.Column
                    width={4}
                    className="u-flex u-directionRow u-flexCenter"
                    style={{ color: colors.red, fontWeight: 'bold' }}
                  >
                    {values.GROSS_Cover}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>

            <Hr />

            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight">
                    {translate('lbl_comment')}
                  </Grid.Column>

                  <Grid.Column width={9} className="u-flex u-directionRow u-alignCenter">
                    <FormField name="Comment" form={form} className="u-fluid u-marginRight-5" />

                    <CommentsModal OperTypeID={3} style={{ marginRight: 0 }} onRowChoose={this.handleComment} />
                  </Grid.Column>

                  <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter">
                    <FormField type="select" form={form} name="OpCodeID" options={this.OpCodes} flex upward floatLeft />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>

            <div className="u-flex u-alignCenter u-spaceBetween u-padding-5">
              <FormField
                type="checkbox"
                form={form}
                label={translateAccLoanCover('chk_order')}
                name="CashOrder"
                disabled={
                  !this.props.CanAddCashin ||
                  !this.props.CashAccounts.length ||
                  LKDate.from(values.CoverDate) < LKDate.from(OpenDayStr)
                }
              />
              {values.CashOrder && (
                <FormField type="checkbox" form={form} name="CashAuth" label={translateAccLoanCover('chk_auth')} />
              )}
            </div>

            {values.CashOrder && (
              <GridContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight">
                      {translateAccLoanCover('lbl_account')}
                    </Grid.Column>

                    <Grid.Column width={12} className="u-flex u-directionRow u-flexCenter">
                      <FormField
                        type="select"
                        form={form}
                        name="CashAccountID"
                        options={this.CashAccounts}
                        onChanged={this.handleCashAccountChanged}
                        flex
                        upward
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter u-pullRight">
                      {translateAccLoanCover('lbl_order_payerdetails')}
                    </Grid.Column>

                    <Grid.Column width={6} className="u-flex u-directionRow u-alignCenter">
                      <ClientDetailsModalTrigger
                        OpenDay={OpenDayStr}
                        client={{
                          ID: this.client.ID,
                          hash: this.client.HashSum_ClientID_,
                          typeID: this.client.ClientTypeID,
                          IDScanCount: this.client.IDScanCount,
                        }}
                        onSuccess={this.handleClientDetails}
                        initialValues={entryDetails}
                        disabled={!this.props.CanEditClient}
                        disableHandfill={disableHandfill}
                        initialClient={this.client}
                        initialIDDoc={this.iddoc}
                        initialDelegate={this.delegate}
                      />

                      <PhysicalClientDetailsModal
                        name="ClientFilesIDCopy"
                        defaultTabId="files"
                        defaultTabIndex={15} // "files"
                        ID={this.loan.ClientID}
                        hash={this.loan.HashSum_ClientID_}
                        permissions={this.props.permissions}
                        noTrigger
                      />

                      <DataSegment style={{ marginLeft: 5 }}>
                        {isIndivid
                          ? `${entryDetails.Client ? entryDetails.Client.FName || entryDetails.Client.Name : ''} ${
                              entryDetails.Client ? entryDetails.Client.Surname || entryDetails.Client.LName : ''
                            }`
                          : `${entryDetails.Client ? entryDetails.Client.FullName : ''}${
                              entryDetails.Delegate ? ' - ' : ''
                            }${entryDetails.Delegate ? entryDetails.Delegate.FullName : ''}`}
                      </DataSegment>
                    </Grid.Column>

                    <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter">
                      <DataSegment>
                        {isIndivid || !entryDetails.Delegate
                          ? entryDetails.Client.CardNumber
                          : entryDetails.Delegate.CardNumber}
                      </DataSegment>
                    </Grid.Column>

                    <Grid.Column width={3} className="u-flex u-directionRow u-flexCenter">
                      <DataSegment>
                        {entryDetails.IDDoc ? entryDetails.IDDoc.OtherIDNumber || entryDetails.IDDoc.IDNumber : ''}
                      </DataSegment>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={4} className="u-flex u-directionRow u-alignCenter">
                      <FormField
                        type="checkbox"
                        form={form}
                        name="print"
                        label={translateAccLoanCover('chk_print')}
                        disabled={!this.props.CanViewEntries}
                      />
                    </Grid.Column>

                    <Grid.Column width={9} className="u-flex u-directionRow u-alignCenter u-spaceBetween">
                      {values.print && (
                        <FormField
                          form={form}
                          type="radiogroup"
                          options={this.printOptions}
                          horizontal
                          name="printOption"
                          onChanged={this.handleDirectionChanged}
                        />
                      )}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            )}
          </div>
        </LKModal>
      </>
    )
  }
}

const LoanCoverTrigger = ({ children, params, onSuccess, permission }) => (
  <>
    <LKModalTrigger name={MODAL_NAME} alias="cover" params={params} permission={permission}>
      {children}
    </LKModalTrigger>

    <LoanCover onSuccess={onSuccess} />

    <LoanCloseCheck onSuccess={onSuccess} />
  </>
)

export { LoanCoverTrigger }

export default LoanCover
